import { Injectable } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { AuthService } from './auth.service';
import { User } from '../models/User/User';
declare let gtag: Function;  // Pour éviter les erreurs TypeScript


@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  public userInfo: User | null = null;
  
  constructor(private gtmService: GoogleTagManagerService, private authService : AuthService) {
     this.authService.userAuthObservable$.subscribe( (u: User | null ) => this.userInfo = u);
  }

  sendPageView(url: string) {
    this.gtmService.pushTag({
      event: 'page_view',
      page_path: url,
      page_title:document.title,
      user_id: this.userInfo?.nomSocieteClient ,
      userName: this.userInfo?.nomSocieteClient ,
      debug_mode: true 
    });
    // gtag('event', 'page_view', {
    //   page_path: url,
    //   page_title:document.title,
    //   user_id: userId ,
    //   debug_mode: true 
    // });

    console.log('📊 Page view sent:',{
      event: 'page_view',
      page_path: url,
      page_title:document.title,
      user_id: this.userInfo?.nomSocieteClient  ,
      debug_mode: true 
    });
  }
  sendEvent(eventName: string, eventParams: any) {
    if (typeof gtag !== 'undefined') {
      gtag('event', eventName, eventParams);
      console.log('send even custom', eventParams)
    } else {
      console.warn("Google Analytics n'est pas encore chargé.");
    }
  }
  setUserId(userId?: string) {
    this.gtmService.pushTag({
      event: 'login',
      user_id: userId ,
      debug_mode: true 
    });
    console.log(`📊 User login: ${userId}`);
  }
  activateDebugGA(){
    this.gtmService.pushTag({
      event: 'gtm.debug_mode',
      debug_mode: true
    });
  }
}


